const c = (d) => `https://widget.ybug.io/button/${d}.js`;
let b = !1;
const i = (d, n) => {
  if (window.ybug_settings = {
    id: d,
    ...n,
    onload: () => {
      var w;
      (w = n == null ? void 0 : n.onload) == null || w.call(n);
    }
  }, !b) {
    const w = document.createElement("script");
    w.async = !0, n != null && n.nonce && (w.nonce = n.nonce), w.src = c(d), document.head.appendChild(w), b = !0;
  }
}, l = {
  /**
   * Install Ybug's Feedback Widget into your app
   *
   * @param app      Vue app instance
   * @param id       Ybug ID
   * @param settings Additional settings (@see https://ybug.io/docs/installation#installation)
   */
  install(d, { id: n, settings: w }) {
    if (!n)
      throw new Error("Please provide a Ybug Project ID");
    i(n, w);
    const r = {
      // @ts-expect-error will not be defined in window
      boot: () => {
        var o;
        return (o = window.Ybug) == null ? void 0 : o.boot();
      },
      // @ts-expect-error will not be defined in window
      show: (o) => {
        var e;
        return (e = window.Ybug) == null ? void 0 : e.show(o);
      },
      // @ts-expect-error will not be defined in window
      hide: (o) => {
        var e;
        return (e = window.Ybug) == null ? void 0 : e.hide(o);
      },
      // @ts-expect-error will not be defined in window
      open: (o) => {
        var e;
        return (e = window.Ybug) == null ? void 0 : e.open(o);
      },
      // @ts-expect-error will not be defined in window
      destroy: () => {
        var o;
        return (o = window.Ybug) == null ? void 0 : o.destroy();
      },
      // @ts-expect-error will not be defined in window
      close: () => {
        var o;
        return (o = window.Ybug) == null ? void 0 : o.close();
      },
      // @ts-expect-error will not be defined in window
      on: (o, e) => {
        var u;
        return (u = window.Ybug) == null ? void 0 : u.on(o, e);
      },
      // @ts-expect-error will not be defined in window
      log: (o, e) => {
        var u;
        return (u = window.Ybug) == null ? void 0 : u.log(o, e);
      },
      // @ts-expect-error will not be defined in window
      setUser: (o) => {
        var e;
        return (e = window.Ybug) == null ? void 0 : e.setUser(o);
      },
      /**
       * Init method can be used to change the settings object.
       * @param settings
       */
      init(o) {
        i(n, o), this.destroy(), this.boot();
      }
    };
    d.config.globalProperties.$ybug = r, d.provide("ybug", r);
  }
};
export {
  l as default
};
